export function validationError(meta, validateOnMount) {
  if (validateOnMount) {
    return meta.error || meta.submitError;
  }

  return (
    (meta.submitFailed || meta.touched) && (meta.error || meta.submitError)
  );
}
